export default __webpack_public_path__ + "static/media/Create_disabled.674aa3ed.jpg";